export default __webpack_public_path__ + "static/media/042-lighthouse.47b363da.png";